function raiseAlertWhenInvalidDirective() {
    'ngInject';

    return {
        require: '^form',
        link(scope, element, attr, ctrl) {
            ctrl.raise_alerts = true;

            const options = scope.$eval(attr.bbRaiseAlertWhenInvalid);
            if (options && options.alert) {
                return ctrl.alert = options.alert;
            }
        }
    };
}

// Form directive to allow users to specify if they want the form to raise alerts when
// there is invalid input.

angular
    .module('BB')
    .directive('bbRaiseAlertWhenInvalid', raiseAlertWhenInvalidDirective);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/raise-alert-when-invalid/raise_alert_when_invalid.directive.js